{
	"weDidNotDetectEditing": "We did not detect editing metadata in your photos. You can upload a preset to help AI better match your editing style, or simply let our AI Color Match algorithm create your style."
}
